import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  dev: defineAsyncComponent(() => import("/app/app/layouts/dev.vue").then(m => m.default || m)),
  monitoring: defineAsyncComponent(() => import("/app/app/layouts/monitoring.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/app/layouts/public.vue").then(m => m.default || m)),
  "shell-error": defineAsyncComponent(() => import("/app/app/layouts/shell-error.vue").then(m => m.default || m))
}